import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
    GoogleAuthProvider,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword
} from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

const LoginPage = () => {
    const { user } = useAuth();
    const [authError, setAuthError] = useState(null);
    const location = useLocation();

    // Check if the user was redirected here from a protected route
    const from = location.state?.from?.pathname || "/";

    // If user is already logged in, redirect them to where they came from
    if (user) {
        return <Navigate to={from} replace />;
    }

    const handleGoogleLogin = async () => {
        setAuthError(null);
        try {
            const provider = new GoogleAuthProvider();
            await signInWithPopup(auth, provider);
        } catch (e) {
            setAuthError(e.message);
        }
    };

    const handleDevLogin = async () => {
        const email = 'test@example.com';
        const password = 'password123';
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (e) {
            // Create user if not found/invalid
            try {
                await createUserWithEmailAndPassword(auth, email, password);
            } catch (createError) {
                setAuthError("Dev create failed: " + createError.message);
            }
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center">
            <div className="max-w-sm w-full p-8 bg-white rounded-xl shadow-lg text-center">
                <h1 className="text-4xl font-bold text-sky-700 mb-6">
                    PaddleMatch
                </h1>
                <div className="flex justify-center flex-col gap-4">
                    <button
                        onClick={handleGoogleLogin}
                        className="w-full py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-semibold shadow-sm flex justify-center items-center gap-2"
                    >
                        Sign in with Google
                    </button>
                    {window.location.hostname === 'localhost' && (
                        <button
                            onClick={handleDevLogin}
                            className="w-full py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors font-semibold shadow-md"
                        >
                            Developer Login (Localhost)
                        </button>
                    )}
                </div>
                {authError && (
                    <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm text-left">
                        <strong>Login Error:</strong>
                        <pre className="whitespace-pre-wrap mt-1 text-xs">{authError}</pre>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoginPage;
